import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { initMetaPixel } from './utils/metaPixel';
import { SalesPage } from './pages/SalesPage';
import { Upsell } from './pages/Upsell';
import { Gracias } from './pages/Gracias';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="3fb9it9bilamk">
      <Routes data-id="element-1" data-mp="3f8nedijx7b8k">
        <Route path="/" element={<SalesPage data-id="element-3" data-mp="2rk47n7gir6il" />} data-id="element-2" data-mp="2rknn8hip5itg" />
        <Route path="/upsell" element={<Upsell data-id="element-5" data-mp="2rikmb2g0a59y" />} data-id="element-4" data-mp="2rlf74v2xls3w" />
        <Route path="/gracias" element={<Gracias data-id="element-7" data-mp="2mmvob3jmwwfr" />} data-id="element-6" data-mp="2mm2n0i3g2z50" />
      </Routes>
    </BrowserRouter>;
}